import { createContext, useState, useEffect} from "react";

import bizzybrie from '../images/games/bizzy-brie-small.png'

export const TVContext = createContext({
    currentChannel: bizzybrie,
    playAnimation: " "

});

export const TVProvider = ({children}) => {
    const [currentChannel, setCurrentChannel] = useState(bizzybrie);
    const [playAnimation, setPlayAnimation] = useState(bizzybrie);

    const updateChannel = (channel) => {
        console.log(channel);
    }

    const value = {currentChannel, updateChannel, setCurrentChannel, playAnimation};

    return <TVContext.Provider value={value}>{children}</TVContext.Provider>
}